module.exports = __webpack_public_path__ + "img/ring-infinity.42e23a15.svg";